import { FunctionComponent } from "react";

export const MobileGarantieLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/mobile-garantie.svg"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="mobile GARANTIE"
    />
  );
};
